export default "__VITE_ASSET__CPmhGwoG__"